import Vue from 'vue'
import vuetify from './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import { configProd, configDev, configGvisionProd, configGvisionDev } from './firebase/config'
import common from './utils/common'
import './prototype.js'
import './utils/gmaps.js'
import google from './utils/google'
import VueAnalytics from 'vue-analytics'
import VueGtag from 'vue-gtag'

Vue.config.productionTip = false

const firebase = require('firebase/app')
switch (location.hostname) {
  case 'realte.site':
    firebase.initializeApp(configProd)
    Vue.prototype.$FUNCTIONS_URL = configProd.FUNCTIONS_URL
    Vue.use(VueAnalytics, {
      id: 'UA-153701216-2',
      router
    })
    Vue.use(VueGtag, {
      config: {
        id: 'G-YB0732P793'
      }
    }, router)
    break
  case 'dev.realte.site':
    firebase.initializeApp(configDev)
    Vue.prototype.$FUNCTIONS_URL = configDev.FUNCTIONS_URL
    Vue.use(VueAnalytics, {
      id: 'UA-153701216-1',
      router
    })
    Vue.use(VueGtag, {
      config: {
        id: 'G-4R60N6ZLM1'
      }
    }, router)
    break
  case 'localhost':
    firebase.initializeApp(configDev)
    Vue.prototype.$FUNCTIONS_URL = configDev.FUNCTIONS_URL
    break
  case 'jibun.vision':
    firebase.initializeApp(configGvisionProd)
    Vue.prototype.$FUNCTIONS_URL = configGvisionProd.FUNCTIONS_URL
    Vue.use(VueGtag, {
      config: {
        id: 'G-MRV0HE158D'
      }
    }, router)
    break
  case 'global-vision-prod.firebaseapp.com':
    firebase.initializeApp(configGvisionProd)
    Vue.prototype.$FUNCTIONS_URL = configGvisionProd.FUNCTIONS_URL
    break
  case 'dev.jibun.vision':
    firebase.initializeApp(configGvisionDev)
    Vue.prototype.$FUNCTIONS_URL = configGvisionDev.FUNCTIONS_URL
    Vue.use(VueGtag, {
      config: {
        id: 'G-QTB4B0ZXYV'
      }
    }, router)
    break
  // case 'localhost':
  //   firebase.initializeApp(configGvisionDev)
  //   Vue.prototype.$FUNCTIONS_URL = configGvisionDev.FUNCTIONS_URL
  //   break
}

new Vue({
  router,
  store,
  common,
  google,
  vuetify,
  render: h => h(App)
}).$mount('#app')
